import React from 'react'
import { Card, CardContent, ThemeProvider, List, ListItem, Typography, FormControlLabel, Tooltip, Switch, IconButton } from '@mui/material'
import { Casino as CasinoIcon, SelectAll as SelectAllICon } from '@mui/icons-material'
import { common as commonColors } from '@mui/material/colors'
import { useTheme } from '@mui/material'

export default function LabelsSwitch(props) {
  const theme = useTheme()
  
  return (
    <Card>
      <CardContent>
        <ThemeProvider theme={props.customTheme}>
          <Typography sx={{ fontWeight: 'bold' }}>Libellés</Typography>
          <List style={{maxHeight: '250px', overflow: 'auto'}} dense>
            {props.labels.current && props.labels.current.map((label, index) => (  
              <ListItem style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}} key={index}>
                <FormControlLabel
                  control={
                    <Tooltip title={(props.activeLabels[label] ? 'Hide ': 'Show ') + label} placement="right">
                      <span>
                        <Switch color={label} checked={props.activeLabels[label]} onChange={props.activeLabelsChanged} name={label} />
                      </span>
                    </Tooltip>
                  }
                  label={
                    <Tooltip title={ props.assetsNumberByLabel.get(label) + ' asset of label ' + label } placement="right">
                      <span>
                        { label + ' (' + props.assetsNumberByLabel.get(label) + ')' }
                      </span>
                    </Tooltip>
                  }
                />

              { props.assetsNumberByLabel.get(label) > 0 &&
                <span style={{marginLeft: '20px'}}>
                  { props.assetsNumberByLabel.get(label) >= 20 &&
                    <Tooltip title={'Randomly center on an asset from label ' + label}>
                      <span>
                        <IconButton size="small" onClick={() => props.centerOnRandomFeatureForLabel(label)} disabled={!props.activeLabels[label]}
                          sx={{
                            color: theme.palette.mode === 'dark' ? commonColors.white: commonColors.black
                          }}>
                          <CasinoIcon/>
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                  { props.assetsNumberByLabel.get(label) < 20 &&
                    <Tooltip title={'Select all the assets from label ' + label}>
                      <span>
                        <IconButton size="small" onClick={() => props.selectFeaturesForLabel(label)} disabled={!props.activeLabels[label]}
                          sx={{
                            color: theme.palette.mode === 'dark' ? commonColors.white: commonColors.black
                          }}>
                          <SelectAllICon/>
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                </span>
              }
              </ListItem>
            ))}
          </List>
        </ThemeProvider>
      </CardContent>
    </Card>
  )
}